export const CONSULTATIONS_TABS = [
  {
    label: 'Agendadas',
    value: 'scheduled',
  },
  {
    label: 'Realizadas',
    value: 'performed',
  },
  {
    label: 'Canceladas',
    value: 'cancelled',
  },
]

export const MAP_STATUS_FROM_PV_TO_CONEXA = {
  A_REALIZAR: 'PENDENTE',
  CANCELADA: 'CANCELADO',
  NO_SHOW: 'CANCELADO',
  NO_SHOW_PAC: 'CANCELADO',
  NO_SHOW_PSI: 'CANCELADO',
}

export const SCREEN_EVENT = {
  AT_PATIENT_MY_CALLS: 'at_patient_my_calls',
}

export const INTERACTION_EVENT = {
  MY_CALLS_SCHEDULE_AGAIN: 'my_calls_schedule_again',
  MY_CALLS_GO_TO_DETAILS: 'my_calls_go_to_details',
}
